import { FC, HTMLAttributes, PropsWithChildren } from "react";
import { classes, stylesheet } from "typestyle";

interface ICard {
  attributes?: HTMLAttributes<HTMLDivElement>;
}

export const Card: FC<PropsWithChildren<ICard>> = (props) => (
  <div
    {...{
      ...props.attributes,
      className: classes(styles.card, props.attributes?.className),
    }}
  >
    {props.children}
  </div>
);

const styles = stylesheet({
  card: {
    borderRadius: 15,
    boxShadow: "0 2px 5px 0 rgba(var(--rgb-color-black), 0.1)",
    backgroundColor: "rgb(var(--rgb-color-white))",
  },
});
